import gql from 'graphql-tag'

export const GET_ORGANIZATION_INTEREST = gql`
  query GetOrganizationInterest($organizationSlug: String!) {
    getOrganizationInterest(organizationSlug: $organizationSlug) {
      id
      name
      categoryId
      organizationId
      type
    }
  }
`
export const CREATE_INTEREST = gql`
  mutation CreateInterest($organizationSlug: String!, $interestInput: InterestInput!) {
    createInterest(organizationSlug: $organizationSlug, interestInput: $interestInput)
  }
`
export const DELETE_INTEREST = gql`
  mutation DeleteInterest($organizationSlug: String!, $interestId: ID!) {
    deleteInterest(organizationSlug: $organizationSlug, interestId: $interestId)
  }
`
export const UPDATE_INTEREST = gql`
  mutation UpdateInterest(
    $organizationSlug: String!
    $interestId: ID!
    $interestInput: InterestInput!
  ) {
    updateInterest(
      organizationSlug: $organizationSlug
      interestId: $interestId
      interestInput: $interestInput
    )
  }
`
